import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';

/**
 * Раздел "Сведения об акте" в ПМ доступен только в безбумажном режиме.
 * Нужны обе настройки сразу, иначе форма отдает старый блок результатов ПМ.
 */
export const getIsPmPaperlessActEnabled = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): boolean => {
  const isEnablePaperlessPassportDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  const isEnablePaperlessAct = settings?.find(
    setting => setting.code === AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_ACT_PRESCRIPTION,
  );

  return isEnablePaperlessPassportDocument && isEnablePaperlessAct?.value === 'true';
};
